/* istanbul ignore file */
import { EnumDropdown, DefaultDropdownProps } from 'framework/form';
import { EMPLOYEE_CONTRACT_TYPES } from '../contracts/contractTypes';

const EmployeeContractTypeDropdown = ({ placeholder, ...restProps }: Omit<DefaultDropdownProps, 'options'>) => (
  <EnumDropdown
    {...restProps}
    options={EMPLOYEE_CONTRACT_TYPES}
    placeholder={placeholder !== undefined ? placeholder : 'Select contract type'}
  />
);

export default EmployeeContractTypeDropdown;
